import React from 'react';

export function getDisplayName(name: string, numberOfPrefixSections: number, delimiter = '_') {
    let result = name;
    for (let i = 0; i < numberOfPrefixSections; i++) {
        result = getStrAfterDelimiter(result, delimiter);
    }
    return result;
}

function getStrAfterDelimiter(str: string, delimiter: string): string {
    return str.slice(str.indexOf(delimiter) + 1, str.length);
}

export const toCamelCase = (str?: string): string => {
    if (!str) return '';
    return str
        .split(' ')
        .map(word =>
            word !== 'IP' ?
                word.replace(/(?:^\w|[A-Z]|\b\w)/g, (letter, index) => {
                    return index === 0 ? letter.toUpperCase() : letter.toLowerCase();
                }) :  word.toUpperCase()
        )
        .join(' ');
};

export const toLowerWithDivider = (str?: string): string => {
    if (!str) return '';
    const allSpacesPattern = / /g;
    return str.replace(allSpacesPattern, '-').toLowerCase();
};

export const formatDescriptionLine = (line: string) => {
    const parts = line.split('**');
    return parts.map((part, index) => (
        React.createElement('span', { key: `${index}-${part}`, className: index % 2 === 0 ? '' : 'bold' }, part)
    ));
};

export const compareObjectsByStringProp = (...keys: string[]): ((a: any, b: any) => number) => {
    return (a: any, b: any): number => {
        for (const key of keys) {
            const comparisonResult = a[key].localeCompare(b[key]);

            if (comparisonResult !== 0) {
                return comparisonResult;
            }
        }
        return 0;
    };
};

export const removeSpacesAndStartWithLowerCase = (value: string): string => {
    return value.replace(/\s/g, '').replace(/^(.)/, (match) => match.toLowerCase());
};